import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getSession } from "../auth";

/**
 * Protège une route : redirige vers /login si pas connecté (token absent ou
 * expiré), ou vers l'accueil si connecté mais rôle non autorisé.
 *
 * Usage :
 *   <ProtectedRoute allowedRoles={["chronometreur"]}>
 *     <Navbar /><Timeserver /><Footer />
 *   </ProtectedRoute>
 */
export default function ProtectedRoute({ children, allowedRoles }) {
    const location = useLocation();
    const session = getSession();

    if (!session) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }

    if (allowedRoles && !allowedRoles.includes(session.role)) {
        return <Navigate to="/" replace />;
    }

    return children;
}